// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.auth.dto.HpOtpSource

export enum HpOtpSource {
  CONTACT = 'contact',
  FAVORITE = 'favorite',
  HIDE = 'hide',
  LOGIN = 'login',
  SAVE_SEARCH = 'saveSearch',
  TOUR = 'tour',
}

export const HpOtpSource_values = [
  HpOtpSource.CONTACT,
  HpOtpSource.FAVORITE,
  HpOtpSource.HIDE,
  HpOtpSource.LOGIN,
  HpOtpSource.SAVE_SEARCH,
  HpOtpSource.TOUR,
] as const;
